import { useIsLoggedInQuery } from 'auth/hooks'
import { useIsAidaAllowed } from '../../hooks/use-is-aida-allowed'
import { useAidaOverlayStore } from '../../stores/overlay-store'
import { useClosedAidaGenerating } from './aida-closed-generating'
import { AidaFloatingButton } from './aida-floating-button'

export function AidaFloatingButtonHost() {
  const allowed = useIsAidaAllowed()
  const overlayOpen = useAidaOverlayStore(state => state.open)
  const isLoggedInQuery = useIsLoggedInQuery()
  const generating = useClosedAidaGenerating(overlayOpen, allowed)
  if (!allowed || overlayOpen) {
    return null
  }

  return <AidaFloatingButton loggedIn={isLoggedInQuery.data === true} generating={generating} />
}
